<template>
  <v-container v-if="cargado" >
    <v-btn color="orange" @click="volver"  left dark> Volver </v-btn>
    <v-btn
      style="margin-left:50px" color="orange" dark  absolute right  @click="obtenerSucesosGlobales(diaEnBusqueda)">
      <v-icon>mdi-refresh</v-icon>
    </v-btn>
    <div style="padding-top:20px; padding-bottom:20px">
    <v-icon size="30" :disabled="menos" @click="obtenerElDiaSeleccionado(diaEnBusqueda, 'menos')">mdi-less-than</v-icon>
    <label v-if="sonDiasAnteriores" >{{this.diaEnPantalla}}</label>
    <label v-else>{{diaLiteralEnPantalla + ', '+this.diaEnPantalla}}</label>
    <v-icon size="30" :disabled="mas" @click="obtenerElDiaSeleccionado(diaEnBusqueda, 'mas')">mdi-greater-than</v-icon>
    </div>

    <v-data-table
      :headers="columnasSucesos"
      :items="arraySucesos"
      :search="buscar"
      :sort-by.sync="valorQueOrdenaLaTabla"
      :sort-desc.sync="tipoDeOrdenacion"
      class="elevation-1"
      no-data-text="No hay datos disponibles"
      :footer-props="{
        'items-per-page-text':'Filas por pagina',
        'items-per-page-options':[-1, 30, 50, 100],
      }"
    >
      <template v-slot:top>
          <v-col cols="12" class="mb-2">
            <v-text-field
              v-model="buscar"
              append-icon="mdi-magnify"
              label="Buscar"
              class="mr-2"
              single-line
              hide-details
            ></v-text-field>
          </v-col>
      </template>
    </v-data-table>

  </v-container>
</template>

<script>
import ApiZD from "../apiZonaDeDescargas";
import { DateTime } from "luxon";
export default {
  data () {
    return {
      columnasSucesos: [
        { text: "Usuario", value: "usuario", filterable: true },
        { text: "Tipo Suceso", value: "tipoSuceso", filterable: true },
        { text: "Fecha/Hora", value: "fechaHora", filterable: true },
        { text: "IP", value: "ip", filterable: false },
        { text: "Archivo", value: "archivo", filterable: true },
        { text: "Carpeta", value: "carpeta", filterable: true },
        { text: "Compartir Archivo con", value: "emailDondeSeComparte", filterable: true }
      ],
      arraySucesos:[],
      cargado: false,
      buscar: "",
      valorQueOrdenaLaTabla: "fechaHora",
      tipoDeOrdenacion: true,
      diaEnPantalla:"",
      menos: false,
      mas: true,
      diaEnBusqueda:"",
      dias: [
      'Domingo',
      'Lunes',
      'Martes',
      'Miércoles',
      'Jueves',
      'Viernes',
      'Sábado',
      ],
      diaLiteralEnPantalla : "",
      sonDiasAnteriores:false
    }
  },
  methods:{
    obtenerSucesosGlobales (dia) {
      let diaLiteral = new Date(dia);
      this.diaLiteralEnPantalla = this.dias[diaLiteral.getDay()];
      this.diaEnPantalla = this.obtenerLiteralFechaHora(dia);
      this.diaEnPantalla =  this.diaEnPantalla.substring(0, this.diaEnPantalla.length - 5);
      this.diaEnBusqueda = dia;

      ApiZD.obtenerSucesosGlobales(dia.substr(0,10))
        .then((resultado) => {
          this.completarArraySucesos(resultado.data.sucesos)
        })
        .catch((e) =>{
          this.arraySucesos = [];
        })
        .finally(() => {
          this.cargado = true;
        });
    },

    //Obtenemos la fecha en formato correcto
    obtenerLiteralFechaHora(fecha) {
      var fechaActual = DateTime.local(DateTime.local().year,DateTime.local().month,DateTime.local().day).toISO();
      let diferenciaDias =
        DateTime.fromISO(fecha).diff(DateTime.fromISO(fechaActual)).as("days")

      if (diferenciaDias > 0 && diferenciaDias < 1 || diferenciaDias == 0){
        this.sonDiasAnteriores = true;
        return "Hoy, " + DateTime.fromISO(fecha).toFormat("DD hh:mm");
      }else if (diferenciaDias < -0 && diferenciaDias >= -1 ){
        this.sonDiasAnteriores = true;
        return "Ayer, " + DateTime.fromISO(fecha).toFormat("DD hh:mm");
      }else{
        this.sonDiasAnteriores = false;
        return DateTime.fromISO(fecha).toFormat("DD hh:mm");
      }
    },

    completarArraySucesos (arraySucesosUsuario) {
      arraySucesosUsuario.forEach((suceso) =>{
        suceso['fechaHora'] = this.obtenerLiteralFechaHora(suceso['fechaHora'])

        //Sacamos el archivo y la carpeta
        if(suceso['archivo']){
          let archivo = suceso['archivo'].split("\\")
          suceso['archivo'] = archivo[archivo.length-1]

          //Eliminamos el nombre de archivo y añadimos la carpeta
          archivo.pop();
          suceso['carpeta']  = archivo.join("/")
        }

      });
      this.arraySucesos = arraySucesosUsuario;
    },

    //Obtenemos el dia seleccionado por el usuario
    obtenerElDiaSeleccionado (dia, accion) {
      let date = new Date(dia)
      let mes;
      let diaModificado;
      let diaActual = new Date();

      //Comprobamos la accion que desea realizare el usuario. Si es subir el dia o bajarlo
      if(accion == "mas"){
        date.setDate(date.getDate() + 1);
      }else{
        this.mas = false;
        date.setDate(date.getDate() - 1);
      }
      //Establecemos el mes con formato correcto
      if((date.getMonth() + 1) < 10)
        mes = '0' + (date.getMonth() + 1)
      else
        mes  = (date.getMonth() + 1)

      if(date.getDate() < 10)
        diaModificado = '0'+date.getDate();
      else
        diaModificado = date.getDate();


      if(date.toISOString().substring(0,10) == diaActual.toISOString().substring(0,10))
        this.mas = true;

      this.obtenerSucesosGlobales(date.getFullYear()+'-'+mes+'-'+diaModificado);
    },
    volver () {
      this.$router.go(-1);
    },

  },
  created () {
    let diaActual = DateTime.local(DateTime.local().year,DateTime.local().month,DateTime.local().day).toISO();
    this.obtenerSucesosGlobales(diaActual);
  }
}
</script>

<style>

</style>